import React from 'react';

type Props = {
  handleClick: () => void;
  label: string;
  icon: string;
};

// For now this button always returns a link with an icon+label.
// if necessary, we can use a prop to show the Icon, defaulting it to true
export const ActionButton: React.FC<Props> = ({ handleClick, label, icon }) => (
  <a className='iconed-label' onClick={handleClick} role='button'>
    <div className='iconed-label__icon'>
      <span className={`icon icon-${icon}`} />
    </div>
    <div className='iconed-label__label'>
      <span className='link-border'>{label}</span>
    </div>
  </a>
);
